import { render, staticRenderFns } from "./FilmBlock.vue?vue&type=template&id=0e499dea&scoped=true&"
import script from "./FilmBlock.vue?vue&type=script&lang=ts&"
export * from "./FilmBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FilmBlock.vue?vue&type=style&index=0&id=0e499dea&lang=scss&scoped=true&"
import style1 from "./FilmBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e499dea",
  null
  
)

export default component.exports